// extracted by mini-css-extract-plugin
module.exports = {"header":"Menu_header__3ooSC","body":"Menu_body__395Sg","close":"Menu_close__3xRxq","options":"Menu_options__37Zu-"};